
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns6430c2b0faa58791d381ee89dd8b9370en from './en.yaml'
            i18n.addResourceBundle('en', '6430c2b0faa58791d381ee89dd8b9370', flattenObject(ns6430c2b0faa58791d381ee89dd8b9370en), true, true);
        
        export default '6430c2b0faa58791d381ee89dd8b9370';
    